import axios from "axios";
import { useState, useContext, useEffect } from "react";
import { AuthContext } from "../context/auth.context";
import { Stack, Typography, Button, Chip } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { VerifiedIcon, CheckedIcon } from "../icons";
import { LoginFooter } from "./footer";
import mime from "mime";
import { base64ToFile, WYSIWYGEditor, FilesProvider } from "../context/files";

export const Answer = () => {
  const { user } = useContext(AuthContext);

  const navigate = useNavigate();

  const [files, setFiles] = useState<File[]>();

  const [encrypted, setEncrypted] = useState<any>();
  const [data, setData] = useState<any>();

  useEffect(() => {
    if (data?.attachments) {
      setFiles(data.attachments?.map((i: any, j: number) => base64ToFile(`data:${mime.getType(i.filename)};base64,` + i.file, i.filename)) ?? []);
    }
  }, [data?.attachments])

  useEffect(() => {
    const formEl = document.getElementById("hack") as HTMLFormElement;

    if (!formEl) {
      navigate('/');
      return;
    }

    const formData = new FormData(formEl);
    const data = Object.fromEntries(formData.entries())
    const result: any = Object.keys(data)?.filter(i => i.indexOf('file') !== 0).reduce((coll, item) => ({ ...coll, [item === 'text' ? 'encrypted_text' : item]: isNaN(Number(data[item])) ? (data[item] as string)[0] === "[" ? JSON.parse((data[item] as string)) : data[item] : Number(data[item]) }), {  });
    
    for (let i = 0; data["file" + i]; i++) {
      result.encrypted_attachments = [ ...(result.encrypted_attachments ?? []), { file: data["file" + i], filename: data["filename" + i] } ];
    }

    setEncrypted(result);

    axios.post(`/eos/decrypt`, result).then(resp => {
      setData(resp.data);

      window.emailSubject = result.subject;
      window.emailText = resp.data.text;
      
      if (resp.data.attachments) {
        window.files = resp.data.attachments;
      }
    }).catch(() => {
      navigate('/page/error')
    });
  }, [user, navigate]);

  return (
    <Stack maxWidth="816px" padding="3rem" spacing={2}>
      <Stack spacing={2}>
        <Stack direction="row" alignItems="center">
          <Stack width="90px">
            <Typography>От кого:</Typography>
          </Stack>

          <Stack flexGrow={1}>
            <Typography>{encrypted?.emailAddressFrom}</Typography>
          </Stack>
        </Stack>
      
        <Stack direction="row" alignItems="center">
          <Stack width="90px">
            
          </Stack>

          <Stack flexGrow={1}>
            <Stack direction="row" spacing={2}>
              <Stack direction="row" alignItems="center" spacing={1}>
                <VerifiedIcon />
                <Typography>Подлинность проверена</Typography>
              </Stack>

              <Stack direction="row" alignItems="center" spacing={1}>
                <CheckedIcon />
                <Typography>Верная подпись</Typography>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Stack>

      <Stack direction="row" alignItems="center">
        <Stack width="90px">
          <Typography>Кому:</Typography>
        </Stack>

        <Stack flexGrow={1}>
          <Typography>{encrypted?.originalTo?.join(', ')}</Typography>
        </Stack>
      </Stack>

      {!!encrypted?.originalCopyTo?.length && (
        <Stack direction="row" alignItems="center">
          <Stack width="90px">
            <Typography>Копия:</Typography>
          </Stack>

          <Stack flexGrow={1}>
            <Typography>{encrypted?.originalCopyTo?.join(', ')}</Typography>
          </Stack>
        </Stack>
      )}

      <Stack direction="row" alignItems="center">
        <Stack width="90px">
          <Typography>Тема:</Typography>
        </Stack>

        <Stack flexGrow={1}>
          <Typography>{encrypted?.subject}</Typography>
        </Stack>
      </Stack>

      {!!data?.attachments?.length && (
        <Stack direction="row">
          <Stack minWidth="90px">
            <Typography>Файлы:</Typography>
          </Stack>

          <Stack flexGrow={1} gap={1} direction="row" flexWrap="wrap">
            {data.attachments.map((i: any, j: number) => (
              <Chip variant="outlined" size="small" key={j} label={i.filename} onClick={() => {
                let a = document.createElement("a"); //Create <a>
                a.href = `data:${mime.getType(i.filename)};base64,` + i.file; //Image Base64 Goes here
                a.download = i.filename; //File name Here
                a.click(); //Downloaded file
              }} />
            ))}
          </Stack>
        </Stack>
      )}

      <Stack>
        {data && files && (
          <FilesProvider
            value={data.text}
            files={files}
            onChange={(text, files) => {
              
            }}
          >
            <WYSIWYGEditor disabled />
          </FilesProvider>
        )}
      </Stack>
      
      <Stack direction="row" spacing={2}>
        <Stack alignItems="center">
          <Link
            onClick={() => {
              localStorage.removeItem("MAIL" + user.uid);
              localStorage.removeItem("FILES" + user.uid);
            }}
            to={`/?to=${encrypted?.emailAddressFrom}`}
          >
            <Button size="large">Ответить</Button>
          </Link>
        </Stack>

        <Stack alignItems="center">
          <Link
            onClick={() => {
              localStorage.removeItem("MAIL" + user.uid);
              localStorage.removeItem("FILES" + user.uid);
            }}
            to={`/?to=${[encrypted?.emailAddressFrom, ...(encrypted?.originalTo?.filter((i: string) => i !== user.sub) ?? [])].join(',')}${encrypted?.originalCopyTo?.length ? `&copyTo=${encrypted?.originalCopyTo?.join(',')}` : ''}`}
          >
            <Button size="large">Ответить всем</Button>
          </Link>
        </Stack>
      </Stack>

      <LoginFooter />
    </Stack>
  )
}
